import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PrivacyPolicyImplRepository } from './privacy-policy-imp.respository';
import { PrivacyPolicyRepository } from '@/core/domain/privacy-policy/repositories/privacy-policy.respository';
import { GetPrivacyPolicyUseCase } from '@/core/domain/privacy-policy/usecases/getPrivacyPolicy.usecase';

const getPrivacyPolicyUseCaseFactory = (repository: PrivacyPolicyRepository) =>
    new GetPrivacyPolicyUseCase(repository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetPrivacyPolicyUseCase,
            useFactory: getPrivacyPolicyUseCaseFactory,
            deps: [PrivacyPolicyImplRepository],
        },
        {
            provide: PrivacyPolicyRepository,
            useClass: PrivacyPolicyImplRepository,
        },
    ],
})
export class PrivacyPolicyDataModule {}
